// extracted by mini-css-extract-plugin
module.exports = {"content":"InboxNotificationsContent-modulecontent1k6"};